<div class="centered-message fxl-column fxla-center-center">
  <div class="icon-container">
    @if (iconName.startsWith('svg')) {
      <mat-icon class="svg-guide-icon" svgIcon="{{ iconName }}"></mat-icon>
    }
    @if (!iconName.startsWith('svg')) {
      <mat-icon class="mat-guide-icon">{{ iconName }}</mat-icon>
    }
  </div>
  <div class="empty-list-text">
    <span>{{ message1 }}</span>
    @if (message2) {
      <br />
    }
    @if (message2) {
      <span>{{ message2 }}</span>
    }
    @if (linkText) {
      <br />
    }
    @if (linkText) {
      <a (click)="linkClickedHandler()" class="url-link">{{ linkText }}</a>
    }
  </div>
</div>
